export const allowedAudioExtensions = [
  '.3ga',
  '.8svx',
  '.aac',
  '.ac3',
  '.aif',
  '.aiff',
  '.alac',
  '.amr',
  '.ape',
  '.au',
  '.dss',
  '.flac',
  '.flv',
  '.m4a',
  '.m4b',
  '.m4p',
  '.m4r',
  '.mp3',
  '.mpga',
  '.ogg',
  '.oga',
  '.mogg',
  '.opus',
  '.qcp',
  '.tta',
  '.voc',
  '.wav',
  '.wma',
  '.wv',
]

export const allowedVideoExtensions = [
  '.webm',
  '.MTS',
  '.M2TS',
  '.TS',
  '.mov',
  '.mp2',
  '.mp4',
  '.m4p',
  '.m4v',
  '.mxf',
]

export function validateFileExtension(filename) {
  const allowedExtensions = [
    ...allowedAudioExtensions,
    ...allowedVideoExtensions,
  ]
  const fileExtension = filename.slice(filename.lastIndexOf('.')).toLowerCase()

  return allowedExtensions.includes(fileExtension)
}

export function isVideoFile(filename) {
  const fileExtension = filename.slice(filename.lastIndexOf('.')).toLowerCase()

  return allowedVideoExtensions.includes(fileExtension)
}
